import Detail from './Detail'
// import Form from './Form'

const InfoBien = {
  Detail,
  // Form
}

export default InfoBien